import { useHistory } from 'react-router-dom'

import { GLOBAL_ROUTE_PATHS } from 'Router/Router.constants'

import { useActiveUser, useIsOrganisation } from 'Hooks'

import { composePath } from 'Portal/src/utilities/composePath/composePath.util'

/**
 * This hook is used to redirect user to the correct confirmation page inside
 * order flow as we have multiple order flows one for organisation and
 * other for employee
 */
export const useRedirectToConfirmationPage = (activeEmployeeId?: string) => {
  const history = useHistory()
  const { activeOrganisation } = useActiveUser()
  const isOrganisation = useIsOrganisation()

  const redirectToConfirmationPage = () => {
    const path = composePath({
      isOrganisation,
      params: {
        employeeId: activeEmployeeId,
        organisationId: activeOrganisation?.id,
      },
      paths: {
        employee: GLOBAL_ROUTE_PATHS.employee.orderConfirmation,
        organisation: activeEmployeeId
          ? GLOBAL_ROUTE_PATHS.organisation.employeeOrderConfirmation
          : GLOBAL_ROUTE_PATHS.organisation.orderConfirmation,
      },
    })

    history.replace(path)
  }

  return {
    redirectToConfirmationPage,
  }
}
